import React, { useEffect, useState, useMemo } from 'react';
import {
  Container, Typography, Snackbar, Alert, IconButton, Tooltip,
  Box, Tabs, Tab, Button, Chip, Grid, Card, CardContent,
  Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, TextField
} from '@mui/material';
import {
  Add, Edit, Delete, Visibility, SwapHoriz, Print, Bolt, Description, Send, Email, WhatsApp, ContentCopy, PictureAsPdf, ImageSearch
} from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import StatusAluguelModal from './components/StatusAluguel';
import BuscaRapidaStatus from './components/BuscaRapidaStatus';
import Badge from '@mui/material/Badge';
import Fab from '@mui/material/Fab';
import API_URL from '../../../config/api';


const FRONTEND_URL = window.location.origin;

const formatDate = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('pt-BR');
};

export default function ControleAlugueis() {
  const [alugueis, setAlugueis] = useState([]);
const [tabIndex, setTabIndex] = useState(0); // 0: Andamento, 1: Pagos, 2: Cancelados
const [snack, setSnack] = useState({ open: false, tipo: 'success', msg: '' });
const navigate = useNavigate();
const [modalStatusOpen, setModalStatusOpen] = useState(false);
const [aluguelSelecionado, setAluguelSelecionado] = useState(null);
const [modalBuscaOpen, setModalBuscaOpen] = useState(false);
const [qtdAndamento, setQtdAndamento] = useState(0);
const [qtdPagos, setQtdPagos] = useState(0);
const [qtdFinalizadosPagos, setQtdFinalizadosPagos] = useState(0);
const [qtdPendentes, setQtdPendentes] = useState(0);
const [qtdCancelados, setQtdCancelados] = useState(0);
const [qtdPendenciasAssinatura, setQtdPendenciasAssinatura] = useState(0);
const [contratosPendentes, setContratosPendentes] = useState([]);
const [modalContratoOpen, setModalContratoOpen] = useState(false);
const [contratoAtual, setContratoAtual] = useState(null);
const [enviandoContrato, setEnviandoContrato] = useState(false);
const [htmlContrato, setHtmlContrato] = useState('');  const [contratoInfo, setContratoInfo] = useState(null);
const [reenviarDialogOpen, setReenviarDialogOpen] = useState(false);

  useEffect(() => {
    fetchAlugueis();
  }, [tabIndex]);

const fetchAlugueis = async () => {
  try {
    const token = localStorage.getItem('token');
    let params = {};

if (tabIndex === 0) {
  params = {
    status_aluguel: [
      'Reservado',
      'Agendado',
      'Ativo',
      'Em Andamento',
      'Atrasado'
    ],
    status_pagamento: ['Pendente', 'Pago']
  };
} else if (tabIndex === 1) {
  params = {
    status_pagamento: 'Pago'
  };
} else if (tabIndex === 2) {
  params = {
    status_aluguel: 'Finalizado',
    status_pagamento: 'Pago'
  };
} else if (tabIndex === 3) {
  params = {
    status_pagamento: 'Pendente'
  };
} else if (tabIndex === 4) {
  params = {
    status_aluguel: 'Cancelado'
  };
}

    const res = await axios.get(`${API_URL}/alugueis/relatorios`, {
      params,
      paramsSerializer: p => {
        const urlSearch = new URLSearchParams();
        Object.entries(p).forEach(([key, val]) => {
          if (Array.isArray(val)) {
            val.forEach(v => urlSearch.append(key, v));
          } else {
            urlSearch.append(key, val);
          }
        });
        return urlSearch.toString();
      },
      headers: { Authorization: `Bearer ${token}` }
    });

    setAlugueis(res.data);

    // Buscar contadores de TODAS as abas para os badges
    const [contadores] = await Promise.all([
      axios.get(`${API_URL}/alugueis/relatorios`, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
    ]);

    const todosAlugueis = contadores.data;

    setQtdAndamento(
      todosAlugueis.filter(a =>
        ['Reservado', 'Agendado', 'Ativo', 'Em Andamento', 'Atrasado'].includes(a.status_aluguel)
      ).length
    );
    setQtdPagos(todosAlugueis.filter(a => a.status_pagamento === 'Pago').length);
    setQtdFinalizadosPagos(
      todosAlugueis.filter(a => a.status_aluguel === 'Finalizado' && a.status_pagamento === 'Pago').length
    );
    setQtdPendentes(todosAlugueis.filter(a => a.status_pagamento === 'Pendente').length);
    setQtdCancelados(todosAlugueis.filter(a => a.status_aluguel === 'Cancelado').length);

    // Buscar contratos pendentes de assinatura
    try {
      const contratosRes = await axios.get(`${API_URL}/contratos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const pendentes = contratosRes.data.filter(c =>
        c.status === 'Aguardando Assinatura'
      );
      setContratosPendentes(pendentes);
      setQtdPendenciasAssinatura(pendentes.length);
    } catch (err) {
      console.error('Erro ao buscar contratos:', err);
      setQtdPendenciasAssinatura(0);
    }

  } catch (error) {
    console.error(error);
    setSnack({ open: true, tipo: 'error', msg: 'Erro ao carregar alugueis.' });
  }
};

  const abrirModalStatus = (aluguel) => {
  setAluguelSelecionado(aluguel);
  setModalStatusOpen(true);
};

const abrirBuscaRapida = () => {
  setModalBuscaOpen(true);
};

const handleSelectAluguel = (aluguel) => {
  setAluguelSelecionado(aluguel);
  setModalBuscaOpen(false);
  setModalStatusOpen(true);
};


const [tableState, setTableState] = useState(() => {
  try {
    const saved = localStorage.getItem('alugueisTableState');
    const parsed = saved ? JSON.parse(saved) : {};
    return {
      density: 'compact',
      columnSizing: {},
      columnPinning: {},
      showColumnFilters: false, // desativa filtros inicialmente
      ...parsed,
    };
  } catch {
    return {
      density: 'compact',
      columnSizing: {},
      columnPinning: {},
      showColumnFilters: false,
    };
  }
});

const handleTrocaStatus = async (aluguelId, novoStatusAluguel, novoStatusPagamento, limpeza) => {
  try {
    const token = localStorage.getItem('token');
    await axios.put(`${API_URL}/alugueis/${aluguelId}/status`, {
      status_aluguel: novoStatusAluguel,
      status_pagamento: novoStatusPagamento,
      ...(novoStatusAluguel === 'Finalizado' && novoStatusPagamento === 'Pago' ? { limpeza } : {})
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    fetchAlugueis();

    if (novoStatusAluguel === 'Finalizado' && novoStatusPagamento === 'Pago') {
      setSnack({
        open: true,
        tipo: 'success',
        msg: 'Veículo liberado para nova locação! Ele voltou para a frota disponível.',
      });
    } else {
      setSnack({
        open: true,
        tipo: 'success',
        msg: 'Status do aluguel atualizado com sucesso!',
      });
    }
  } catch {
    setSnack({
      open: true,
      tipo: 'error',
      msg: 'Erro ao atualizar status do aluguel!',
    });
  }
};


  const deleteAluguel = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/alugueis/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchAlugueis();
      setSnack({ open: true, tipo: 'success', msg: 'Aluguel removido.' });
    } catch {
      setSnack({ open: true, tipo: 'error', msg: 'Erro ao remover.' });
    }
  };

  const toggleStatus = async (row) => {
    const newStatus = row.status_pagamento === 'Pendente' ? 'Pago' : 'Pendente';
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API_URL}/alugueis/${row.id}/status`, { status_pagamento: newStatus }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchAlugueis();
      setSnack({ open: true, tipo: 'success', msg: `Status alterado para ${newStatus}.` });
    } catch {
      setSnack({ open: true, tipo: 'error', msg: 'Erro ao alterar status.' });
    }
  };

  // Função para abrir modal de contrato
  const abrirModalContrato = async (aluguel) => {
    try {
      setContratoAtual(aluguel);
      setModalContratoOpen(true);
      
      // Buscar contrato do aluguel
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/contratos/aluguel/${aluguel.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data) {
        setHtmlContrato(response.data.conteudo_html || '');
        setContratoInfo(response.data);
      }
    } catch (error) {
      console.error('Erro ao buscar contrato:', error);
      setHtmlContrato('');
      setContratoInfo(null);
      setSnack({ open: true, tipo: 'warning', msg: 'Contrato ainda não foi gerado para este aluguel' });
    }
  };

  // Copiar link de assinatura
  const copiarLinkAssinatura = () => {
    if (contratoInfo && contratoInfo.token_assinatura) {
      const link = `${FRONTEND_URL}/contratos/assinar/${contratoInfo.token_assinatura}`;
      navigator.clipboard.writeText(link);
      setSnack({ open: true, tipo: 'success', msg: 'Link copiado para área de transferência!' });
    }
  };

  // Função para gerar/regenerar contrato
  const gerarContrato = async () => {
    try {
      setEnviandoContrato(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/contratos/gerar`, {
        id_aluguel: contratoAtual.id,
        id_template: 1, // Usar template padrão ou permitir seleção
        enviar_whatsapp: false,
        enviar_email: false
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.sucesso) {
        setHtmlContrato(response.data.contrato.html);
        setSnack({ open: true, tipo: 'success', msg: 'Contrato gerado com sucesso!' });
      }
    } catch (error) {
      console.error('Erro ao gerar contrato:', error);
      setSnack({ open: true, tipo: 'error', msg: 'Erro ao gerar contrato' });
    } finally {
      setEnviandoContrato(false);
    }
  };

  // Função para enviar contrato por WhatsApp
  const enviarContratoWhatsApp = async () => {
    try {
      setEnviandoContrato(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/contratos/enviar/whatsapp`, {
        id_aluguel: contratoAtual.id
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.sucesso) {
        setSnack({ open: true, tipo: 'success', msg: 'Contrato enviado por WhatsApp!' });
      }
    } catch (error) {
      console.error('Erro ao enviar por WhatsApp:', error);
      setSnack({ open: true, tipo: 'error', msg: error.response?.data?.erro || 'Erro ao enviar por WhatsApp' });
    } finally {
      setEnviandoContrato(false);
    }
  };

  // Função para enviar contrato por E-mail
  const enviarContratoEmail = async () => {
    try {
      setEnviandoContrato(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/contratos/enviar/email`, {
        id_aluguel: contratoAtual.id
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.sucesso) {
        setSnack({ open: true, tipo: 'success', msg: 'Contrato enviado por E-mail!' });
      }
    } catch (error) {
      console.error('Erro ao enviar por E-mail:', error);
      setSnack({ open: true, tipo: 'error', msg: error.response?.data?.erro || 'Erro ao enviar por E-mail' });
    } finally {
      setEnviandoContrato(false);
    }
  };

  const gerarPdfCupom = async (aluguel) => {
    try {
      const jsPDF = (await import('jspdf')).default;
      const autoTable = (await import('jspdf-autotable')).default;
      
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [80, 200] // Formato cupom: 80mm de largura
      });

      let y = 10;
      
      // Cabeçalho
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('EASY LOCADORA', 40, y, { align: 'center' });
      y += 6;
      
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.text('Comprovante de Aluguel', 40, y, { align: 'center' });
      y += 8;
      
      // Linha separadora
      doc.line(5, y, 75, y);
      y += 5;
      
      // Informações do Aluguel
      doc.setFontSize(8);
      doc.text(`Nº Aluguel: ${aluguel.id}`, 5, y);
      y += 5;
      doc.text(`Data: ${formatDate(new Date())}`, 5, y);
      y += 7;
      
      // Cliente
      doc.setFont('helvetica', 'bold');
      doc.text('CLIENTE:', 5, y);
      y += 4;
      doc.setFont('helvetica', 'normal');
      doc.text(aluguel.nome_cliente || '-', 5, y);
      y += 7;
      
      // Veículo
      doc.setFont('helvetica', 'bold');
      doc.text('VEÍCULO:', 5, y);
      y += 4;
      doc.setFont('helvetica', 'normal');
      doc.text(`${aluguel.modelo} - ${aluguel.placa}`, 5, y);
      y += 7;
      
      // Período
      doc.setFont('helvetica', 'bold');
      doc.text('PERÍODO:', 5, y);
      y += 4;
      doc.setFont('helvetica', 'normal');
      doc.text(`Retirada: ${formatDate(aluguel.data_retirada)}`, 5, y);
      y += 4;
      doc.text(`Prev. Devolução: ${formatDate(aluguel.data_devolucao)}`, 5, y);
      y += 4;
      if (aluguel.data_real_devolucao) {
        doc.text(`Real Devolução: ${formatDate(aluguel.data_real_devolucao)}`, 5, y);
        y += 4;
      }
      doc.text(`Tipo: ${aluguel.tipo_periodo} (${aluguel.quantidade_periodos}x)`, 5, y);
      y += 4;
      doc.text(`Total Dias: ${aluguel.dias_total || 0}`, 5, y);
      y += 7;
      
      // Valores
      doc.line(5, y, 75, y);
      y += 5;
      
      const valorDiaria = parseFloat(aluguel.valor_diaria || 0);
      const valorBruto = parseFloat(aluguel.valor_bruto || 0);
      const desconto = parseFloat(aluguel.desconto_valor || 0);
      const valorTotal = parseFloat(aluguel.valor_total || 0);
      const diasAtraso = parseInt(aluguel.dias_atraso || 0);
      const valorMulta = parseFloat(aluguel.valor_multa || 0);
      
      doc.text(`Diária: R$ ${valorDiaria.toFixed(2)}`, 5, y);
      y += 4;
      doc.text(`Valor Bruto: R$ ${valorBruto.toFixed(2)}`, 5, y);
      y += 4;
      if (desconto > 0) {
        doc.text(`Desconto: R$ ${desconto.toFixed(2)}`, 5, y);
        y += 4;
      }
      if (diasAtraso > 0) {
        doc.text(`Dias Atraso: ${diasAtraso}`, 5, y);
        y += 4;
        doc.text(`Multa: R$ ${valorMulta.toFixed(2)}`, 5, y);
        y += 4;
      }
      
      doc.line(5, y, 75, y);
      y += 5;
      
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text(`TOTAL: R$ ${valorTotal.toFixed(2)}`, 5, y);
      y += 7;
      
      // Status
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.text(`Status Aluguel: ${aluguel.status_aluguel}`, 5, y);
      y += 4;
      doc.text(`Status Pagamento: ${aluguel.status_pagamento}`, 5, y);
      y += 7;
      
      // Pagamento
      if (aluguel.forma_pagamento) {
        doc.text(`Forma Pagto: ${aluguel.forma_pagamento}`, 5, y);
        y += 4;
        if (aluguel.bandeira_cartao) {
          doc.text(`Bandeira: ${aluguel.bandeira_cartao}`, 5, y);
          y += 4;
        }
      }
      
      if (aluguel.observacoes_pagamento) {
        y += 3;
        doc.text('Observações:', 5, y);
        y += 4;
        const obs = doc.splitTextToSize(aluguel.observacoes_pagamento, 70);
        doc.text(obs, 5, y);
      }
      
      // Rodapé
      y += 10;
      doc.line(5, y, 75, y);
      y += 5;
      doc.setFontSize(7);
      doc.text('Obrigado pela preferência!', 40, y, { align: 'center' });
      
      // Abrir PDF em nova aba para preview antes de imprimir
      window.open(doc.output('bloburl'), '_blank');
      
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      setSnack({ open: true, tipo: 'error', msg: 'Erro ao gerar cupom.' });
    }
  };

  const downloadContratoPdf = async (aluguel) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/contratos/aluguel/${aluguel.id}/pdf`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `contrato-aluguel-${aluguel.id}.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar contrato:', error);
      setSnack({ open: true, tipo: 'error', msg: 'Erro ao baixar contrato PDF.' });
    }
  };

  const columns = useMemo(() => [
    { accessorKey: 'nome_cliente', header: 'Cliente' },
    { accessorKey: 'placa', header: 'Placa' },
    { accessorKey: 'modelo', header: 'Modelo' },
    { accessorKey: 'tipo_periodo', header: 'Tipo' },
    { accessorKey: 'quantidade_periodos', header: 'Qtd' },
    {
      accessorKey: 'data_retirada',
      header: 'Retirada',
      Cell: ({ cell }) => formatDate(cell.getValue())
    },
    {
      accessorKey: 'data_devolucao',
      header: 'Prev. Devolução',
      Cell: ({ cell }) => formatDate(cell.getValue())
    },
    {
      accessorKey: 'data_real_devolucao',
      header: 'Real Devolução',
      Cell: ({ cell }) => formatDate(cell.getValue())
    },
    { accessorKey: 'dias_total', header: 'Dias Total' },
    { accessorKey: 'dias_atraso', header: 'Atraso' },
    {
      accessorKey: 'desconto_valor',
      header: 'Desconto',
      Cell: ({ cell }) => `R$ ${parseFloat(cell.getValue() || 0).toFixed(2).replace('.', ',')}`,
    },
    {
      accessorKey: 'valor_total',
      header: 'Valor Total',
      Cell: ({ cell }) => `R$ ${parseFloat(cell.getValue()).toFixed(2).replace('.', ',')}`,
    },
    {
      accessorKey: 'status_aluguel',
      header: 'Status Aluguel',
      Cell: ({ cell }) => <Chip label={cell.getValue()} color="info" size="small" />
    },
    {
      accessorKey: 'status_pagamento',
      header: 'Status Pagamento',
      Cell: ({ cell }) => {
        const status = cell.getValue();
        const color = status === 'Pago' ? 'success' : status === 'Pendente' ? 'warning' : 'default';
        return <Chip label={status} color={color} size="small" />;
      }
    },
    {
    accessorKey: 'observacoes_pagamento',
    header: 'Observações Pagamento',
    Cell: ({ cell }) => (
      <span style={{ whiteSpace: 'pre-wrap', color: '#222' }}>
        {cell.getValue() || '-'}
      </span>
    ),
    size: 180,
  },
  {
    accessorKey: 'contrato_status',
    header: 'Contrato',
    size: 130,
    Cell: ({ cell }) => {
      const status = cell.getValue();
      if (!status) return <Chip label="Sem contrato" size="small" variant="outlined" sx={{ fontSize: 11 }} />;
      if (status === 'assinado') return <Chip label="✓ Assinado" color="success" size="small" sx={{ fontSize: 11 }} />;
      return <Chip label="Aguardando" color="warning" size="small" sx={{ fontSize: 11 }} />;
    }
  },

    {
      id: 'acoes',
      header: 'Ações',
      enableColumnFilter: false,
      enableHiding: false,
      enableColumnOrdering: false,
      size: 350,
      Cell: ({ row }) => (
        <Box display="flex" gap={1}>
          <Tooltip title="Visualizar">
            <IconButton color="primary" size="small" onClick={() => navigate(`/alugueis/${row.original.id}`)}>
              <Visibility />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar promo / devolução">
            <IconButton color="warning" size="small" onClick={() => navigate(`/alugueis/${row.original.id}/editar`)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Gerenciar Contrato">
            <IconButton
              size="small"
              sx={{ color: row.original.contrato_status === 'assinado' ? '#2e7d32' : '#1976d2' }}
              onClick={() => abrirModalContrato(row.original)}
            >
              <Description />
            </IconButton>
          </Tooltip>
          <Tooltip title={row.original.contrato_status === 'assinado' ? 'Baixar Contrato PDF' : 'Contrato não assinado'}>
            <span>
              <IconButton
                size="small"
                sx={{ color: row.original.contrato_status === 'assinado' ? '#c62828' : '#bdbdbd' }}
                onClick={() => downloadContratoPdf(row.original)}
                disabled={row.original.contrato_status !== 'assinado'}
              >
                <PictureAsPdf />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={row.original.contrato_status ? 'Reenviar link de assinatura' : 'Sem contrato gerado'}>
            <span>
              <IconButton
                size="small"
                sx={{ color: row.original.contrato_status && row.original.contrato_status !== 'assinado' ? '#7b1fa2' : '#bdbdbd' }}
                onClick={() => { setContratoAtual(row.original); setReenviarDialogOpen(true); }}
                disabled={!row.original.contrato_status || row.original.contrato_status === 'assinado'}
              >
                <Send />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Trocar status">
            <IconButton color="secondary" size="small" onClick={() => abrirModalStatus(row.original)}>
              <SwapHoriz />
            </IconButton>
          </Tooltip>
          <Tooltip title="Imprimir Recibo">
            <IconButton size="small" sx={{ color: '#f78b00' }} onClick={() => gerarPdfCupom(row.original)}>
              <Print />
            </IconButton>
          </Tooltip>
          <Tooltip title="Ver Vistoria">
            <IconButton
              size="small"
              sx={{ color: '#0288d1' }}
              onClick={() => navigate(`/vistorias?aluguel=${row.original.id}`)}
            >
              <ImageSearch />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton color="error" size="small" onClick={() => deleteAluguel(row.original.id)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      )
    },
  ], [navigate]);

  return (
    <Container maxWidth={false} disableGutters sx={{ px: 3, mt: 2, mb: 4, width: '100%' }}>

       <Fab
      color="primary"
      aria-label="Novo Aluguel"
      sx={{
        position: 'fixed',
        bottom: { xs: 24, md: 32 },
        right: { xs: 24, md: 48 },
        zIndex: 1000,
        boxShadow: 4,
      }}
      onClick={() => navigate('/alugueis/nova')}
    >
      <Add />
    </Fab>
      <Typography variant="h6" mb={2}>Controle de Aluguéis</Typography>

   <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)} sx={{ mb: 2 }}>
        <Tab
          label={
            <Badge badgeContent={qtdAndamento} color="info">
              🚗 Andamento
            </Badge>
          }
        />
        <Tab
          label={
            <Badge badgeContent={qtdPagos} color="success">
              💰 Pagos
            </Badge>
          }
        />
        <Tab
          label={
            <Badge badgeContent={qtdFinalizadosPagos} color="primary">
              ✅ Finalizados e Pagos
            </Badge>
          }
        />
        <Tab
          label={
            <Badge badgeContent={qtdPendentes} color="warning">
              🕒 Pagamento Pendente
            </Badge>
          }
        />
        <Tab
          label={
            <Badge badgeContent={qtdCancelados} color="error">
              ❌ Cancelados
            </Badge>
          }
        />
        <Tab
          label={
            <Badge badgeContent={qtdPendenciasAssinatura} color="warning">
              ✍️ Pendência Assinatura
            </Badge>
          }
        />
      </Tabs>



     {tabIndex === 5 ? (
        // Conteúdo especial para aba de Pendências de Assinatura
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 2, color: '#666' }}>
            Contratos aguardando assinatura dos clientes
          </Typography>
          {contratosPendentes.length === 0 ? (
            <Box sx={{ p: 3, bgcolor: '#f5f5f5', borderRadius: 2, textAlign: 'center' }}>
              <Typography variant="body2" color="textSecondary">
                ✅ Nenhum contrato pendente de assinatura
              </Typography>
            </Box>
          ) : (
            <Grid container spacing={2}>
              {contratosPendentes.map(contrato => (
                <Grid item xs={12} md={6} lg={4} key={contrato.id}>
                  <Card sx={{ border: '1px solid #e0e0e0' }}>
                    <CardContent>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="h6" sx={{ fontSize: '0.95rem', fontWeight: 'bold' }}>
                          {contrato.numero_contrato}
                        </Typography>
                        <Chip
                          label={
                            contrato.status_raw === 'pendente' ? 'Pendente' :
                            contrato.status_raw === 'enviado' ? 'Enviado' :
                            contrato.status_raw === 'visualizado' ? 'Visualizado' :
                            contrato.status || 'Aguardando'
                          }
                          size="small"
                          color={
                            contrato.status_raw === 'pendente' ? 'default' :
                            contrato.status_raw === 'enviado' ? 'info' :
                            contrato.status_raw === 'visualizado' ? 'primary' : 'warning'
                          }
                        />
                      </Box>
                      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                        Cliente: {contrato.nome_cliente || contrato.cliente?.nome || 'N/A'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                        Gerado: {contrato.data_geracao ? new Date(contrato.data_geracao).toLocaleDateString('pt-BR', { timeZone: 'America/Manaus' }) : '-'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                        Expira: {contrato.data_expiracao ? new Date(contrato.data_expiracao).toLocaleDateString('pt-BR', { timeZone: 'America/Manaus' }) : '-'}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<Visibility />}
                          onClick={() => window.open(`${FRONTEND_URL}/contratos/assinar/${contrato.token_assinatura}`, '_blank')}
                        >
                          Ver Contrato
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      ) : (
        <>
          <Button
            variant="contained"
            startIcon={<Add />}
            sx={{ mb: 2, mr: 1 }}
            onClick={() => navigate('/alugueis/nova')}
          >
            Novo Aluguel
          </Button>

          <Button
            variant="contained"
            color="secondary"
            startIcon={<Bolt />}
            sx={{ mb: 2 }}
            onClick={abrirBuscaRapida}
          >
            Trocar Status Rápido
          </Button>
        </>
      )}

      {tabIndex !== 5 && (
        <Box sx={{ 
          width: '100%', 
          overflowX: 'auto',
     border: '1px solid #e0e0e0',
     borderRadius: '4px',
     '&::-webkit-scrollbar': {
       width: '12px',
       height: '12px'
     },
     '&::-webkit-scrollbar-track': {
       backgroundColor: '#f1f1f1'
     },
     '&::-webkit-scrollbar-thumb': {
       backgroundColor: '#FF8C00',
       borderRadius: '6px',
       '&:hover': {
         backgroundColor: '#e07b00'
       }
     }
   }}>
     <MaterialReactTable
        columns={columns}
        data={alugueis}
        localization={MRT_Localization_PT_BR}
        enableColumnFilters
        enablePagination
        enableSorting
        enableColumnOrdering
        enableColumnResizing
        enableHiding
        state={tableState}
        onStateChange={(updater) => {
          const newState = typeof updater === 'function' ? updater(tableState) : updater;
          setTableState(newState);
          localStorage.setItem('alugueisTableState', JSON.stringify(newState));
        }}
        initialState={{ 
          showColumnFilters: true, 
          pagination: { pageSize: 20 },
          density: 'compact',
          columnVisibility: { acoes: true }
        }}
        muiTablePaperProps={{ 
          elevation: 0,
          sx: { 
            boxShadow: 'none'
          }
        }}
        muiTableContainerProps={{
          sx: { 
            maxHeight: 'none'
          }
        }}
          muiTableBodyRowProps={({ row }) => {
    const atraso = row.original.dias_atraso > 0;
    const pendente = row.original.status_pagamento === 'Pendente';
    return {
      sx: {
        backgroundColor: atraso
          ? '#fff3e0' // laranja claro para atraso
          : pendente
            ? '#ffebee' // vermelho claro para pendente
            : row.index % 2 === 0
              ? '#f5f5f5' // cinza claro para linhas pares
              : '#fff',   // branco para ímpares
        transition: 'background 0.2s',
      }
    };
  }}
      />
        </Box>
      )}

<BuscaRapidaStatus
  open={modalBuscaOpen}
  onClose={() => setModalBuscaOpen(false)}
  onSelectAluguel={handleSelectAluguel}
/>

{aluguelSelecionado && (
   <StatusAluguelModal
    open={modalStatusOpen}
    onClose={() => setModalStatusOpen(false)}
    aluguel={aluguelSelecionado}
    onUpdate={(novoStatusAluguel, novoStatusPagamento, limpeza) =>
      handleTrocaStatus(aluguelSelecionado.id, novoStatusAluguel, novoStatusPagamento, limpeza)
    }
  />
)}

      {/* Dialog Reenviar Link de Assinatura */}
      <Dialog
        open={reenviarDialogOpen}
        onClose={() => setReenviarDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Send sx={{ color: '#7b1fa2' }} />
            <Typography variant="h6">Reenviar Link de Assinatura</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {contratoAtual && (
            <Box>
              <Typography variant="body2" sx={{ mb: 2, color: '#555' }}>
                Cliente: <strong>{contratoAtual.nome_cliente}</strong>
              </Typography>
              <Typography variant="body2" sx={{ mb: 3, color: '#555' }}>
                Escolha como reenviar o link de assinatura:
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button
                  variant="contained"
                  startIcon={enviandoContrato ? <CircularProgress size={18} /> : <WhatsApp />}
                  onClick={async () => { await enviarContratoWhatsApp(); setReenviarDialogOpen(false); }}
                  disabled={enviandoContrato || !contratoAtual.telefone}
                  sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#128C7E' } }}
                >
                  WhatsApp
                </Button>
                <Button
                  variant="contained"
                  startIcon={enviandoContrato ? <CircularProgress size={18} /> : <Email />}
                  onClick={async () => { await enviarContratoEmail(); setReenviarDialogOpen(false); }}
                  disabled={enviandoContrato || !contratoAtual.email}
                  color="primary"
                >
                  E-mail
                </Button>
              </Box>
              {!contratoAtual.telefone && (
                <Alert severity="warning" sx={{ mt: 2 }}>Cliente sem telefone cadastrado</Alert>
              )}
              {!contratoAtual.email && (
                <Alert severity="warning" sx={{ mt: 1 }}>Cliente sem e-mail cadastrado</Alert>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReenviarDialogOpen(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Gerenciamento de Contrato */}
      <Dialog 
        open={modalContratoOpen} 
        onClose={() => setModalContratoOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Description sx={{ color: '#1976d2' }} />
            <Typography variant="h6">Gerenciar Contrato</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {contratoAtual && (
            <Box>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Aluguel #{contratoAtual.id} - {contratoAtual.nome_cliente}
              </Typography>
              
              {htmlContrato ? (
                <>
                  {/* Status de Assinatura */}
                  {contratoInfo && (
                    <Box sx={{ mb: 2 }}>
                      <Chip 
                        label={contratoInfo.status === 'assinado' ? 'Contrato Assinado' : 'Aguardando Assinatura'}
                        color={contratoInfo.status === 'assinado' ? 'success' : 'warning'}
                        sx={{ mb: 1 }}
                      />
                      {contratoInfo.status === 'assinado' && contratoInfo.data_assinatura && (
                        <Typography variant="caption" display="block" color="text.secondary">
                          Assinado em {new Date(contratoInfo.data_assinatura).toLocaleString('pt-BR')}
                        </Typography>
                      )}
                    </Box>
                  )}
                  
                  <Box 
                    sx={{ 
                      border: '1px solid #ddd', 
                      borderRadius: 1, 
                      p: 2, 
                      mb: 2, 
                      maxHeight: '400px', 
                      overflow: 'auto',
                      bgcolor: '#f9f9f9'
                    }}
                    dangerouslySetInnerHTML={{ __html: htmlContrato }}
                  />
                  
                  {/* Link de Assinatura */}
                  {contratoInfo && contratoInfo.token_assinatura && (
                    <Box sx={{ mb: 2, p: 2, bgcolor: '#f0f7ff', borderRadius: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Link para Assinatura:
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <TextField
                          fullWidth
                          size="small"
                          value={`${FRONTEND_URL}/contratos/assinar/${contratoInfo.token_assinatura}`}
                          InputProps={{ readOnly: true }}
                          sx={{ bgcolor: 'white' }}
                        />
                        <Button
                          variant="outlined"
                          startIcon={<ContentCopy />}
                          onClick={copiarLinkAssinatura}
                        >
                          Copiar
                        </Button>
                      </Box>
                    </Box>
                  )}
                  
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    {contratoInfo?.status === 'Assinado' && (
                      <Button
                        variant="contained"
                        startIcon={<PictureAsPdf />}
                        onClick={() => downloadContratoPdf(contratoAtual)}
                        sx={{ bgcolor: '#c62828', '&:hover': { bgcolor: '#b71c1c' } }}
                      >
                        Baixar PDF Assinado
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      startIcon={enviandoContrato ? <CircularProgress size={20} /> : <WhatsApp />}
                      onClick={enviarContratoWhatsApp}
                      disabled={enviandoContrato || !contratoAtual.telefone}
                      sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#128C7E' } }}
                    >
                      Enviar WhatsApp
                    </Button>
                    
                    <Button
                      variant="contained"
                      startIcon={enviandoContrato ? <CircularProgress size={20} /> : <Email />}
                      onClick={enviarContratoEmail}
                      disabled={enviandoContrato || !contratoAtual.email}
                      color="primary"
                    >
                      Enviar E-mail
                    </Button>
                    
                    <Button
                      variant="outlined"
                      startIcon={enviandoContrato ? <CircularProgress size={20} /> : <Send />}
                      onClick={gerarContrato}
                      disabled={enviandoContrato}
                      color="secondary"
                    >
                      Regenerar Contrato
                    </Button>
                  </Box>
                  
                  {!contratoAtual.telefone && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                      Cliente sem telefone cadastrado
                    </Alert>
                  )}
                  
                  {!contratoAtual.email && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                      Cliente sem e-mail cadastrado
                    </Alert>
                  )}
                </>
              ) : (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                    Nenhum contrato gerado ainda para este aluguel
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={enviandoContrato ? <CircularProgress size={20} /> : <Description />}
                    onClick={gerarContrato}
                    disabled={enviandoContrato}
                  >
                    {enviandoContrato ? 'Gerando...' : 'Gerar Contrato'}
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalContratoOpen(false)}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={snack.tipo}>{snack.msg}</Alert>
      </Snackbar>
    </Container>
  );
}
